import { takeLatest, call, put, all } from 'redux-saga/effects';

// SERVICES
import { ApiResponse, postApi } from 'services/_api';
import { CHANNEL, PATH_BOLSA_POVO } from 'services/_path';

// TYPES
import { Types } from './types';

// ACTIONS
import {
	consultarTiposResidenciasSuccess,
	consultarTiposResidenciasFailure,
} from './action';

function* consultarTiposResidenciasRequest() {
	const response: ApiResponse = yield call(
		postApi,
		PATH_BOLSA_POVO,
		`enderecos/${CHANNEL}/tipos-residencias`,
		{},
	);

	if (response.status === 200) {
		yield put(consultarTiposResidenciasSuccess(response));
	} else if (response.error) {
		yield put(consultarTiposResidenciasFailure());
	}
}

export default all([
	takeLatest(
		Types.CONSULTAR_TIPOS_RESIDENCIAS_REQUEST,
		consultarTiposResidenciasRequest,
	),
]);
